<template>
  <v-app>
    <v-toolbar
      class="bg-grey text-black text-left"
      title="NKY Storm Lacrosse"
    ></v-toolbar>
    <v-container fluid class="pa-0">
      <v-carousel cycle hide-delimiters :show-arrows="false">
        <v-carousel-item
          v-for="(item, i) in items"
          :key="i"
          :src="item.src"
          cover
        >
          <div>
            <v-container class="mt-10">
              <v-row>
                <v-col cols="12" md="2" offset="5" class="text-center">
                  <v-img
                    :width="300"
                    aspect-ratio="16/9"
                    cover
                    class="ml-auto logo"
                    src="https://nothernkentuckystorm.s3.us-east-2.amazonaws.com/Storm+Bolt+Only-01.png"
                  ></v-img>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-carousel-item>
      </v-carousel>
    </v-container>
    <v-container class="mb-10 form-container">
      <v-row>
        <v-col>
          <Responses />
        </v-col>
      </v-row>
    </v-container>
    <v-footer class="bg-grey text-black text-center d-flex flex-column">
      <div>
        <v-btn
          v-for="(icon, i) in icons"
          :href="icon.url"
          :key="i"
          class="mx-4"
          :icon="icon.icon"
          variant="text"
          target="_blank"
        ></v-btn>
      </div>

      <div class="pt-0">
        We are Northern Kentuckys first summer lacrosse club. The Storm is
        Northern Kentucky’s first summer lacrosse club. The goal of summer
        lacrosse is to assist players wanting to take their game to the next
        level. We give players the opportunity to compete with some of the best
        players from across the midwest and beyond. Our goal is to develop
        quality players through positive instruction, ample field play and
        honest player assessment from our dedicated coaching staff. Summer
        lacrosse allows players who want to get in one more game, exposure to
        numerous college coaches from all levels (D1, D2, D3 and Independents).
        Since we are a Northern Kentucky based club we recruit from the Northern
        Kentucky/Greater Cincinnati area. This gives participants the chance to
        engage with their fellow players from the other local teams, making for
        a great experience for the players and their families.
      </div>

      <v-divider></v-divider>

      <div>{{ date }} &copy; <strong>NKY Storm</strong></div>
    </v-footer>
  </v-app>
</template>

<script>
import Responses from "./components/Responses.vue";
export default {
  name: "App",
  components: {
    Responses,
  },
  data() {
    return {
      date: "",
      icons: [
        {
          icon: "mdi-facebook",
          url: "https://www.facebook.com/kystormlacrosse/",
        },
        {
          icon: "mdi-twitter",
          url: "https://twitter.com/kystormlacrosse?lang=en",
        },
        { icon: "mdi-instagram", url: "" },
      ],
      items: [
        {
          src: "https://nothernkentuckystorm.s3.us-east-2.amazonaws.com/IMG_0357.JPG",
        },
        {
          src: "https://nothernkentuckystorm.s3.us-east-2.amazonaws.com/IMG_0365.JPG",
        },
        {
          src: "https://nothernkentuckystorm.s3.us-east-2.amazonaws.com/IMG_0383.JPG",
        },
        {
          src: "https://nothernkentuckystorm.s3.us-east-2.amazonaws.com/IMG_0606.JPG",
        },
      ],
    };
  },
  created() {
    document.title = "NKY Storm";
    const year = new Date();
    this.date = year.getFullYear();
  },
  mounted() {
    //getToken();
    // function getToken() {
    //   try {
    //     // Send a GET request to the API to fetch token
    //     axios
    //       .get("https://nkystormadmin.com/admin/api/config")
    //       .then(function (response) {
    //         console.log("token:" + JSON.stringify(response));
    //       });
    //   } catch (error) {
    //     // Log the error
    //     console.log(error);
    //   }
    // }
  },
};
</script>

<style>
body {
  margin: 0px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .logo {
    display: none;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .logo {
    display: none;
  }
}
</style>
